<div mat-dialog-content class="dialog-custom" >
  <div [ngClass]="getClassBody(data.enumTipoMensagem)">
    <mat-icon>{{getIcon(data.enumTipoMensagem)}}</mat-icon>
    <h1 mat-dialog-title>{{getType(data.enumTipoMensagem)}}</h1>
    <p>{{ data.msg }}</p>
  </div>
</div>
<div mat-dialog-actions class="buttons dialog-button">
    <button mat-button mat-raised-button (click)="onCancel()" tabindex="2" [ngClass]="getClassButtonNo(data.enumTipoMensagem)" >{{data.isConfirm ? 'Não' : 'OK' }}</button>
    <button mat-button mat-raised-button (click)="onConfirm()" tabindex="-1" *ngIf="data.isConfirm" [ngClass]="getClassButtonYes(data.enumTipoMensagem)">Sim</button>
</div>
